<script setup lang="ts">
import type { MenuItem } from '@global-types/nav/menuItem';
import { computed } from 'vue';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';

const props = defineProps<{
  menuItem: MenuItem;
}>();

const computedClasses = computed<string[]>(() => {
  const classes = [];

  if (props.menuItem.class) {
    classes.push(props.menuItem.class);
  }

  if (props.menuItem.type === 'divider') {
    classes.push('user-menu-divider');
  }

  if ([ 'button', 'link' ].includes(props.menuItem.type)) {
    classes.push('user-menu-item');
  }

  return classes;
});
</script>

<template>
  <li
    :class="computedClasses"
  >
    <hr v-if="menuItem.type === 'divider'">

    <Typography
      v-if="menuItem.type === 'button'"
      class="user-menu-item__content"
      :class="typeof menuItem.icon === 'string' ? menuItem.icon : ''"
      variant="body"
      @click="menuItem.click"
    >
      <Icon
        v-if="menuItem.icon"
        :svg="menuItem.icon"
        :custom-class="menuItem.iconName"
        height="24"
        width="24"
        :fill="menuItem.iconColor ?? 'gray-darker'"
      />
      {{ menuItem.name }}
    </Typography>

    <a
      v-if="menuItem.link"
      :href="menuItem.link"
      class="user-menu-item__content"
    >
      <Icon
        v-if="menuItem.icon"
        :svg="menuItem.icon"
        :custom-class="menuItem.iconName"
        height="24"
        width="24"
        :fill="menuItem.iconColor ?? 'gray-darker'"
      />
      {{ menuItem.name }}
    </a>
  </li>
</template>
